export const DocumentRoute = {
  DOCUMENT: {
    path: 'documents',
    name: 'documents'
  },
  DOCUMENTS_UPLOAD: {
    path: 'documents/upload',
    name: 'documents.upload'
  }
};
